import { render, staticRenderFns } from "./resourceDatabaseManagementAdd.vue?vue&type=template&id=6771c2d6&scoped=true"
import script from "./resourceDatabaseManagementAdd.vue?vue&type=script&lang=js"
export * from "./resourceDatabaseManagementAdd.vue?vue&type=script&lang=js"
import style0 from "./resourceDatabaseManagementAdd.vue?vue&type=style&index=0&id=6771c2d6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6771c2d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6771c2d6')) {
      api.createRecord('6771c2d6', component.options)
    } else {
      api.reload('6771c2d6', component.options)
    }
    module.hot.accept("./resourceDatabaseManagementAdd.vue?vue&type=template&id=6771c2d6&scoped=true", function () {
      api.rerender('6771c2d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/backstage/webSet/resourceManagement/resourceDatabaseManagementAdd.vue"
export default component.exports